<script>
export default {
  name: 'AdminLoadingState',
  props: {
    text: {
      type: String,
      default: '로딩 중...',
    },
  },
}
</script>

<template>
  <div class="admin-loading-state admin-page-card">
    <v-progress-circular indeterminate color="primary" size="22" width="2" />
    <span>{{ text }}</span>
  </div>
</template>

<style scoped>
.admin-loading-state {
  padding: var(--admin-space-5);
  display: inline-flex;
  align-items: center;
  gap: var(--admin-space-2);
  color: var(--admin-color-text-secondary);
}
</style>
